var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edit_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AF6A34",
    d: "M3.46 12.284a1 1 0 0 0 .106-.009l3.004-.527a.18.18 0 0 0 .095-.05l7.57-7.57a.18.18 0 0 0 0-.251L11.265.907a.18.18 0 0 0-.126-.052.18.18 0 0 0-.127.052l-7.57 7.57a.2.2 0 0 0-.05.095l-.527 3.003a.6.6 0 0 0 .168.532.6.6 0 0 0 .425.177M4.662 9.17l6.477-6.475 1.308 1.309-6.476 6.475-1.588.28zm9.909 4.614H1.429a.57.57 0 0 0-.572.571v.643c0 .079.065.143.143.143h14a.143.143 0 0 0 .143-.143v-.643a.57.57 0 0 0-.571-.571"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "edit_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgEdit;